export enum PatientDetailNodeType {
  DoctorDetail = "DoctorDetail",
  InvitationResendDetail = "InvitationResendDetail",
  PDFDetail = "PDFDetail",
  PatientDetail = "DoctorDeleteDoctorDelete",
}
